const TIP_THANKS_REWARD_AMOUNT_STORAGE_PREFIX =
  'grato.tip.thanks.reward-amount';

export type TipThanksPageLocationState = {
  rewardAmount?: number | null;
};

function normalizeTipThanksRewardAmount(
  rewardAmount: number | null | undefined,
) {
  if (
    rewardAmount === null ||
    rewardAmount === undefined ||
    !Number.isFinite(rewardAmount) ||
    rewardAmount < 0
  ) {
    return null;
  }

  return Math.floor(rewardAmount);
}

function createTipThanksRewardAmountStorageKey(walletUUID: string) {
  return `${TIP_THANKS_REWARD_AMOUNT_STORAGE_PREFIX}:${walletUUID}`;
}

export function persistTipThanksRewardAmount(
  walletUUID: string,
  rewardAmount: number | null | undefined,
) {
  if (typeof window === 'undefined' || walletUUID.length === 0) {
    return;
  }

  const normalizedRewardAmount = normalizeTipThanksRewardAmount(rewardAmount);

  try {
    if (normalizedRewardAmount === null) {
      window.sessionStorage.removeItem(
        createTipThanksRewardAmountStorageKey(walletUUID),
      );
      return;
    }

    window.sessionStorage.setItem(
      createTipThanksRewardAmountStorageKey(walletUUID),
      String(normalizedRewardAmount),
    );
  } catch {
    // sessionStorage can be unavailable in privacy mode.
  }
}

export function resolveTipThanksRewardAmount(
  walletUUID: string,
  locationState?: TipThanksPageLocationState | null,
) {
  const stateRewardAmount = normalizeTipThanksRewardAmount(
    locationState?.rewardAmount,
  );

  if (stateRewardAmount !== null) {
    return stateRewardAmount;
  }

  if (typeof window === 'undefined' || walletUUID.length === 0) {
    return null;
  }

  try {
    const storedRewardAmount = window.sessionStorage.getItem(
      createTipThanksRewardAmountStorageKey(walletUUID),
    );

    if (storedRewardAmount === null) {
      return null;
    }

    return normalizeTipThanksRewardAmount(
      Number.parseInt(storedRewardAmount, 10),
    );
  } catch {
    return null;
  }
}
